import React from 'react';
import classNames from 'classnames';
import { ICONS } from 'src/common/constants';
import Document from 'src/components/Document';
import FontAwesomeIcon from 'src/components/Icon';
import { useWarrantyExpiredAssets } from 'src/SharedCustomHooks/UseWarrantyExpiredAssets/useWarrantyExpiredAssets';
import './AssetItem.scss';

export interface AssetItemProps {
  asset: any;
  isExpired: boolean;
  serviceRequestFormData: any;
  onSetServiceRequestFormData: any;
  onFetchFaqsNotesDocuments: any;
}

const AssetItem = ({
  asset,
  isExpired,
  serviceRequestFormData,
  onSetServiceRequestFormData,
  onFetchFaqsNotesDocuments,
}: AssetItemProps) => {
  const { notifyWarrantyExpired } = useWarrantyExpiredAssets();

  const assetName: string =
    asset.item && asset.item.name ? asset.item.name : '';

  const handleAssetClick = () => {
    if (isExpired) {
      notifyWarrantyExpired(assetName);
      return;
    }

    onSetServiceRequestFormData({
      asset_serial_number: asset.serialNumber,
      asset_item_make:
        asset.item && asset.item.makeName ? asset.item.makeName : '',
      asset_item_model: asset.item && asset.item.model ? asset.item.model : '',
      asset_item_name:
        asset.item && asset.item.itemTypeIcons && asset.item.itemTypeIcons.name
          ? asset.item.itemTypeIcons.name
          : '',
      asset_item_nameDescription: assetName,
      asset_item_type: null,
      asset_item_id: asset.item && asset.item.id ? asset.item.id : '',
      assetId: asset.id,
      itemId: asset.item && asset.item.id ? asset.item.id : '',
      assetWarrantyExpiresAt: asset.warrantExpiration
        ? asset.warrantExpiration
        : '',
      annotatateImage: false,
    });

    if (asset.item && asset.item.id) {
      onFetchFaqsNotesDocuments(asset.item.id);
    }
  };

  if (asset.item === null) return null;

  return (
    <div
      className={classNames('sr-asset-grid-cell', {
        'is-warranty-expired': isExpired,
      })}
    >
      <Document
        active={serviceRequestFormData.assetId === asset.id}
        adaptiveSize
        onClick={handleAssetClick}
        headline={assetName}
        icon={
          <FontAwesomeIcon
            glyph={
              ICONS[
                asset.item &&
                asset.item.itemTypeIcons &&
                asset.item.itemTypeIcons.name
                  ? asset.item.itemTypeIcons.name
                  : ''
              ]
            }
            weight="light"
          />
        }
      />
    </div>
  );
};

export default AssetItem;
